import ApiService from "@/common/api/api.service";


const ProjetoRN316 = {
    
    salvar(form) {
        if(form.id)
            return ApiService.put(`ProjetoRN316`, form);
        return ApiService.post(`ProjetoRN316`, form);
    },

    listar(empresaId, tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`ProjetoRN316?EmpresaId=${empresaId}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    buscar(id){
        return ApiService.get(`ProjetoRN316/${id}`);
    },

    salvarDesembolso(form) {
        if(form.id)
            return ApiService.put(`ProjetoRN316/desembolso`, form);
        return ApiService.post(`ProjetoRN316/desembolso`, form);
    },

    excluirDesembolso(id){
        return ApiService.delete(`ProjetoRN316/desembolso`, {id});
    },

    downloadDesembolso(id){
        return ApiService.downloadFile(`ProjetoRN316/desembolso/download-arquivo?id=${id}`);
    },

    salvarCusto(form) {
        if(form.id)
            return ApiService.put(`ProjetoRN316/custo-proprio`, form);
        return ApiService.post(`ProjetoRN316/custo-proprio`, form);
    },

    excluirCusto(id){
        return ApiService.delete(`ProjetoRN316/custo-proprio`, {id});
    },

    downloadCusto(id){
        return ApiService.downloadFile(`ProjetoRN316/custo-proprio/download-arquivo?id=${id}`);
    },

}

export default ProjetoRN316;
